import { PROMOCODES_EXTERNAL_SELLER_ICON, PROMOCODES_MEDX_ICON, PROMOCODES_TS_WITH_TEXT_ICON } from 'constants/Images';
import { BeVoucher } from 'types/voucher';
import { getFormattedWithDate } from 'utils/DateTimeUtils';
import { VoucherInfoProps } from '../components/SectionVoucherInfo/VoucherInfo';

export const adaptVoucherInfo = (voucherInfo: BeVoucher): VoucherInfoProps => {
  try {
    const expiredTime = new Date(voucherInfo.endTime).getTime() - Date.now();
    const isLessThanThreeDays = expiredTime < 3 * 24 * 60 * 60 * 1000;
    const usedPercent = (voucherInfo.usageTotal / voucherInfo.maxUsage) * 100;
    const hasMaxUsage = !!voucherInfo.maxUsage && usedPercent > 0;
    const timePercent =
      100 - +((expiredTime / (new Date(voucherInfo.endTime).getTime() - new Date(voucherInfo.startTime).getTime())) * 100).toFixed(0);

    const shouldDisplayUsedPercent = hasMaxUsage;
    const shouldDisplayTimePercent = !!voucherInfo.usageTotal && !shouldDisplayUsedPercent;
    const shouldDisplayCountdownExpiredTime = isLessThanThreeDays;

    return {
      title: voucherInfo.shortName,
      subTitle: voucherInfo.displayName,
      code: voucherInfo.code,
      expiredDate: voucherInfo.endTime ? getFormattedWithDate(new Date(voucherInfo.endTime), 'DD/MM/YYYY') : '',
      content: voucherInfo.description,
      condition: voucherInfo.conditionDescription,
      imageUrl: voucherInfo.voucherImage || getDefaultVoucherImageUrl(voucherInfo.promotionOrganizer),
      usedPercent: +((voucherInfo.usageTotal / voucherInfo.maxUsage) * 100).toFixed(0),
      timePercent: +timePercent.toFixed(0),
      restExpiredTime: expiredTime / 1000,
      shouldDisplayUsedPercent,
      shouldDisplayCountdownExpiredTime,
      shouldDisplayTimePercent,
      status: voucherInfo.actionStatus,
      usageTotal: voucherInfo.usageTotal,
      // href: voucherInfo.actionStatus === 'INVALID' ? voucherInfo.actionLink : undefined,
      message: voucherInfo.errorCode === 'KCB_VERIFY_REQUIRED' ? '' : voucherInfo.errorMessage,
      sellerLink: voucherInfo.linkToStore,
      sellerName: voucherInfo.sellerName,
    };
  } catch (e) {
    console.error(e);
    return {
      title: '',
      code: '',
      expiredDate: '',
      content: '',
      condition: '',
      imageUrl: '',
      usedPercent: 0,
      timePercent: 0,
      restExpiredTime: 0,
      shouldDisplayUsedPercent: false,
      shouldDisplayCountdownExpiredTime: false,
      shouldDisplayTimePercent: false,
      status: 'INVALID',
      usageTotal: 0,
      message: '',
      sellerLink: '',
      sellerName: '',
    }
  }
};

const getDefaultVoucherImageUrl = (promotionOrganizer: BeVoucher['promotionOrganizer']) => {
  switch (promotionOrganizer) {
    case 'SELLER_CENTER': {
      return PROMOCODES_EXTERNAL_SELLER_ICON;
    }
    case 'INTERNAL_SELLER': {
      return PROMOCODES_MEDX_ICON;
    }
    default: {
      return PROMOCODES_TS_WITH_TEXT_ICON;
    }
  }
};

